import {
  fetchApi,
  getApiBaseUrl,
  getApiBaseUrlv2,
} from 'state/services/apiService';
import { AUTH_TYPES } from 'auth/state/service/authApi';
import { parseResponse } from './utils';

export function fetchEkgRecording(recordingId) {
  return fetchApi({
    url: `${getApiBaseUrl()}/recordings/${recordingId}`,
    authType: AUTH_TYPES.BEARER,
  })
    .then(res => res.json())
    .catch(err => {
      console.log(err);
      throw err;
    });
}

export function fetchEkgQT(
  recordingId,
  isServiceProviderEnabled,
  isServiceInterpretationFeatureEnabled,
) {
  const baseUrl = `/recordings/${recordingId}/qt`;
  const URL =
    isServiceProviderEnabled && !isServiceInterpretationFeatureEnabled
      ? `${getApiBaseUrl()}${baseUrl}`
      : `${getApiBaseUrlv2()}${baseUrl}`;
  return fetchApi({
    url: URL,
    authType: AUTH_TYPES.BEARER,
  })
    .then(res => res.json())
    .catch(err => {
      console.log(err);
      throw err;
    });
}

export function fetchPostEkgQTRequest(recordingId) {
  return fetchApi({
    url: `${getApiBaseUrl()}/recordings/${recordingId}/requestQt`,
    method: 'POST',
    authType: AUTH_TYPES.BEARER,
    jsonError: true,
  })
    .then(res => res.json())
    .then(parseResponse)
    .catch(err => {
      console.log(err);
      throw err;
    });
}

export function fetchPostQTValues(
  teamId,
  recordingId,
  qtValues,
  isServiceProviderEnabled,
  isServiceInterpretationFeatureEnabled,
  qtConfirm,
) {
  const baseUrl = `${getApiBaseUrl()}/teams/${teamId}/recordings/${recordingId}`;
  let URL = '';
  if (isServiceProviderEnabled && !isServiceInterpretationFeatureEnabled) {
    URL = `${baseUrl}/qt`;
  } else {
    URL = qtConfirm ? `${baseUrl}/qt/confirm` : `${baseUrl}/qt/save`;
  }
  return fetchApi({
    url: URL,
    method: 'POST',
    authType: AUTH_TYPES.BEARER,
    body: JSON.stringify(qtValues),
  })
    .then(res => res.json())
    .then(parseResponse)
    .catch(err => {
      console.log(err);
      throw err;
    });
}



// WEBPACK FOOTER //
// ./src/state/services/recordingApiService.js